import { NgModule } from '@angular/core';

import { ImageQualityRatingService
       } from 'app/controls/image-quality-rating/image-quality-rating.service';
import { MatModule } from 'core/material/mat.module';
import { PipesModule } from 'core/pipes/pipes.module';
import { PriceModule } from 'core/price/price.module';
import { AdventCalendarOverlayComponent
       } from './additional-info-item-components/advent-calendar-overlay.component'; // tslint:disable-line
import { ExternalHTMLContentComponent
       } from './additional-info-item-components/external-html-content.component'; // tslint:disable-line
import { SmartSortedComponent
       } from './additional-info-item-components/smart-sorted.component';
import { CollageDesignerComponent } from './collage-designer.component';
import { DesignStepModule } from './design-step/design-step.module';
import { FontInjectorService } from './font-injector.service';

import { TranslationModule } from 'core/translation/translation.module';

@NgModule({
  imports: [
    PriceModule,
    DesignStepModule,
    MatModule,
    PipesModule,
    TranslationModule,
  ],
  declarations: [
    AdventCalendarOverlayComponent,
    CollageDesignerComponent,
    ExternalHTMLContentComponent,
    SmartSortedComponent,
  ],
  providers: [
    FontInjectorService,
    ImageQualityRatingService
  ],
  exports: [
    CollageDesignerComponent,
  ],
  entryComponents: [
    AdventCalendarOverlayComponent,
    ExternalHTMLContentComponent,
    SmartSortedComponent,
  ]
})
export class CollageDesignerModule { }



// WEBPACK FOOTER //
// ./src/app/collage-designer/collage-designer.module.ts